(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["utopia-anuncio-producto"] && !Shopify.designMode) return;
  try {
    
    (function () {
      document.querySelectorAll('[data-utopia-anuncios-track]').forEach(function (track) {
        var items = track.querySelectorAll('[class*="__item"]');
        var actual = 0;

        function mostrar(indice) {
          items.forEach(function (item, i) {
            item.classList.toggle(item.className.split(' ').find(function (c) { return c.indexOf('--activo') === -1 && c.indexOf('__item') !== -1; }) + '--activo', i === indice);
          });
        }

        function siguiente() {
          actual = (actual + 1) % items.length;
          mostrar(actual);
        }

        function anterior() {
          actual = (actual - 1 + items.length) % items.length;
          mostrar(actual);
        }

        var wrapper = track.closest('[role="region"]');
        var btnNext = wrapper.querySelector('[data-utopia-anuncio-next]');
        var btnPrev = wrapper.querySelector('[data-utopia-anuncio-prev]');

        var intervalo;
        function reiniciarIntervalo() {
          clearInterval(intervalo);
          if (items.length > 1) {
            intervalo = setInterval(siguiente, 4000);
          }
        }

        if (btnNext) btnNext.addEventListener('click', function () { siguiente(); reiniciarIntervalo(); });
        if (btnPrev) btnPrev.addEventListener('click', function () { anterior(); reiniciarIntervalo(); });

        reiniciarIntervalo();
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["utopia-anuncio"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var track = document.querySelector('[data-utopia-anuncios-track]');
    if (!track) return;

    var items = track.querySelectorAll('.utopia-anuncios__item');
    var actual = 0;

    function mostrar(indice) {
      items.forEach(function (item, i) {
        item.classList.toggle('utopia-anuncios__item--activo', i === indice);
      });
    }

    function siguiente() {
      actual = (actual + 1) % items.length;
      mostrar(actual);
    }

    function anterior() {
      actual = (actual - 1 + items.length) % items.length;
      mostrar(actual);
    }

    var btnNext = document.querySelector('[data-utopia-anuncio-next]');
    var btnPrev = document.querySelector('[data-utopia-anuncio-prev]');

    if (btnNext) btnNext.addEventListener('click', function () { siguiente(); reiniciarIntervalo(); });
    if (btnPrev) btnPrev.addEventListener('click', function () { anterior(); reiniciarIntervalo(); });

    var intervalo;
    function reiniciarIntervalo() {
      clearInterval(intervalo);
      if (items.length > 1) {
        intervalo = setInterval(siguiente, 4000);
      }
    }
    reiniciarIntervalo();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["utopia-barra-sticky"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var barra = document.querySelector('[data-utopia-sticky-barra]');
    if (!barra) return;

    var botonReal = document.querySelector('[id^="ProductSubmitButton-"]');
    var botonSticky = barra.querySelector('[data-utopia-sticky-boton]');

    if (botonSticky) {
      botonSticky.addEventListener('click', function () {
        if (!botonReal) return;
        if (botonReal.disabled) return;
        botonReal.click();
      });
    }

    if (!botonReal) return;

    function actualizarEstado() {
      botonSticky.disabled = !!botonReal.disabled;
    }
    actualizarEstado();
    var observadorAtributos = new MutationObserver(actualizarEstado);
    observadorAtributos.observe(botonReal, { attributes: true, attributeFilter: ['disabled'] });

    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          barra.classList.toggle('utopia-sticky-visible', !entrada.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observador.observe(botonReal);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["utopia-comparador"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-utopia-comp-marco]').forEach(function (marco) {
      var rango = marco.querySelector('[data-utopia-comp-rango]');
      if (!rango) return;

      function actualizar() {
        marco.style.setProperty('--utopia-comp-pos', rango.value + '%');
      }

      rango.addEventListener('input', actualizar);
      actualizar();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["utopia-resenas-completas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-utopia-resc-grid]').forEach(function (grid) {
      var contenedor = grid.closest('div').parentElement || grid.parentElement;
      var buscador = contenedor.querySelector('[data-utopia-resc-buscar]');
      var orden = contenedor.querySelector('[data-utopia-resc-orden]');
      var sinResultados = contenedor.querySelector('[data-utopia-resc-sin-resultados]');
      var tarjetas = Array.prototype.slice.call(grid.querySelectorAll('[data-utopia-resc-tarjeta]'));

      function filtrar() {
        var texto = (buscador && buscador.value || '').toLowerCase().trim();
        var visibles = 0;
        tarjetas.forEach(function (tarjeta) {
          var coincide = texto === '' || tarjeta.textContent.toLowerCase().indexOf(texto) !== -1;
          tarjeta.hidden = !coincide;
          if (coincide) visibles++;
        });
        if (sinResultados) sinResultados.hidden = visibles !== 0;
      }

      function ordenar() {
        var criterio = orden ? orden.value : 'recientes';
        var ordenadas = tarjetas.slice();

        if (criterio === 'mejor') {
          ordenadas.sort(function (a, b) {
            return parseFloat(b.getAttribute('data-estrellas')) - parseFloat(a.getAttribute('data-estrellas'));
          });
        } else if (criterio === 'peor') {
          ordenadas.sort(function (a, b) {
            return parseFloat(a.getAttribute('data-estrellas')) - parseFloat(b.getAttribute('data-estrellas'));
          });
        } else {
          ordenadas.sort(function (a, b) {
            return parseInt(a.getAttribute('data-indice'), 10) - parseInt(b.getAttribute('data-indice'), 10);
          });
        }

        ordenadas.forEach(function (tarjeta) {
          grid.appendChild(tarjeta);
        });
      }

      if (buscador) buscador.addEventListener('input', filtrar);
      if (orden) orden.addEventListener('change', ordenar);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["utopia-resenas-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-utopia-resg-grid]').forEach(function (grid) {
      var observador = new IntersectionObserver(
        function (entradas) {
          entradas.forEach(function (entrada) {
            if (entrada.isIntersecting) {
              grid.classList.add('utopia-resg-en-vista');
              observador.unobserve(grid);
            }
          });
        },
        { threshold: 0.2 }
      );
      observador.observe(grid);
    });

    document.querySelectorAll('[data-utopia-resg-flechas]').forEach(function (flechas) {
      var contenedor = flechas.parentElement;
      var grid = contenedor.querySelector('[data-utopia-resg-grid]');
      var anterior = flechas.querySelector('[data-utopia-resg-anterior]');
      var siguiente = flechas.querySelector('[data-utopia-resg-siguiente]');
      if (!grid) return;

      if (anterior) {
        anterior.addEventListener('click', function () {
          grid.scrollBy({ left: -grid.clientWidth, behavior: 'smooth' });
        });
      }
      if (siguiente) {
        siguiente.addEventListener('click', function () {
          grid.scrollBy({ left: grid.clientWidth, behavior: 'smooth' });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["utopia-testimonio-carrusel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-utopia-testi-pista]').forEach(function (pista) {
      var slides = pista.querySelectorAll('[class*="__slide"]');
      var contenedor = pista.parentElement;
      var puntos = contenedor.querySelectorAll('[data-utopia-testi-punto]');
      var actual = 0;

      function claseBase(el) {
        return Array.prototype.find.call(el.classList, function (c) {
          return c.indexOf('__slide') !== -1 && c.indexOf('--activo') === -1;
        });
      }

      function mostrar(indice) {
        slides.forEach(function (slide, i) {
          slide.classList.toggle(claseBase(slide) + '--activo', i === indice);
        });
        puntos.forEach(function (punto, i) {
          punto.classList.toggle(punto.className.split(' ').find(function (c) { return c.indexOf('--activo') === -1 && c.indexOf('__punto') !== -1; }) + '--activo', i === indice);
        });
        actual = indice;
      }

      puntos.forEach(function (punto, i) {
        punto.addEventListener('click', function () {
          mostrar(i);
          reiniciar();
        });
      });

      var intervalo;
      var velocidad = parseInt(pista.getAttribute('data-autoplay'), 10) || 0;
      function reiniciar() {
        clearInterval(intervalo);
        if (velocidad > 0 && slides.length > 1) {
          intervalo = setInterval(function () {
            mostrar((actual + 1) % slides.length);
          }, velocidad * 1000);
        }
      }
      reiniciar();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["utopia-testimonios1"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var botones = document.querySelectorAll('[data-utopia-play-btn]');

    botones.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var video = document.getElementById(btn.getAttribute('data-video-id'));
        if (!video) return;

        video.play();
        video.setAttribute('controls', 'controls');
        btn.classList.add('utopia-testimonios__play--oculto');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
